export const data1 = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
];

export const data2 = [
  {
    name: "State",
    value: 400,
  },
  {
    name: "District",
    value: 300,
  },
  {
    name: "Block",
    value: 300,
  },
  {
    name: "Institutes",
    value: 200,
  },
];
export const dataVlab = [
  {
    value: 100,
    name: "test1",
    fill: "#8884d8",
  },
  {
    value: 80,
    name: "test2",
    fill: "#83a6ed",
  },
  {
    value: 50,
    name: "test3",
    fill: "#8dd1e1",
  },
  {
    value: 40,
    name: "test4",
    fill: "#82ca9d",
  },
];
export const dataCiso = [
  {
    name: "18-24",
    uv: 31.47,
    pv: 2400,
    fill: "#8884d8",
  },
  {
    name: "25-29",
    uv: 26.69,
    pv: 4567,
    fill: "#83a6ed",
  },
  {
    name: "30-34",
    uv: -15.69,
    pv: 1398,
    fill: "#8dd1e1",
  },
];

export const cryptoData = [
  {
    btc: 7300,
    ltc: 0.2,
    ada: 1.2,
    xrp: 0.9,
    xlm: 0.2,
  },
  {
    btc: 7290,
    ltc: 0.3,
    ada: 1.3,
    xrp: 1.2,
    xlm: 0.4,
  },
  {
    btc: 7120,
    ltc: 0.5,
    ada: 1.4,
    xrp: 1.3,
    xlm: 0.2,
  },
  {
    btc: 7290,
    ltc: 0.3,
    ada: 1.3,
    xrp: 1.2,
    xlm: 0.4,
  },
  {
    btc: 7090,
    ltc: 0.4,
    ada: 2,
    xrp: 5,
    xlm: 0.2,
  },
  {
    btc: 7100,
    ltc: 0.2,
    ada: 1,
    xrp: 7.2,
    xlm: 0.5,
  },
  {
    btc: 7700,
    ltc: 1,
    ada: 4,
    xrp: 7.1,
    xlm: 0.8,
  },
  {
    btc: 7500,
    ltc: 1.6,
    ada: 4.6,
    xrp: 7.7,
    xlm: 1.2,
  },
  {
    btc: 7610,
    ltc: 1,
    ada: 2,
    xrp: 5,
    xlm: 2,
  },
  {
    btc: 7090,
    ltc: 0.4,
    ada: 2,
    xrp: 5,
    xlm: 0.2,
  },
  {
    btc: 7100,
    ltc: 0.2,
    ada: 1,
    xrp: 7.2,
    xlm: 0.5,
  },
  {
    btc: 7500,
    ltc: 1.6,
    ada: 4.6,
    xrp: 7.7,
    xlm: 1.2,
  },
];
